import React from 'react';
import { useParams } from 'react-router-dom';
import { findTechnology, technologyMetadata } from './catalog';
import { TechnologyPage } from './markup';
import PageMetadata from '../seo/MetaHead';
import NotFound from '../NotFound';
import '../ai/aiServices.css';
import './details.css';
export default function TechnologyRoute({ ios = false }) {
 const { slug } = useParams();
 const technology = findTechnology(ios ? 'ios' : slug);
 if (!technology) return <NotFound />;
 return <PageMetadata meta={technologyMetadata(technology)}><TechnologyPage technology={technology} /></PageMetadata>;
}
